import { render, staticRenderFns } from "./CellRendererFeaturedPositions.vue?vue&type=template&id=684abace"
import script from "./CellRendererFeaturedPositions.vue?vue&type=script&lang=js"
export * from "./CellRendererFeaturedPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports